

var tracker = {

    trackEvent: function(category, action, label) {
        // console.log("ga('send', 'event')", category, action, label);
        window.ga('send', 'event', category, action, label);
    },


    trackPageview: function(pageName) {
        // ga('set', 'page', pageName);
        // console.log("ga('send', 'pageview')", pageName);
        window.ga('send', 'pageview', pageName);
    }

};


module.exports = tracker;






/** WEBPACK FOOTER **
 ** ./src/scripts/client/utilities/tracker.js
 **/